import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { LanguageComponent } from './components/language/language.component';
import { allLanguages } from './shared/constants/languages';
import { StakingComponent } from './components/staking/staking.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';

const routesLang: Routes = allLanguages.filter((lang) => lang.value !== 'en').map((lang) => {
  return {
    path: lang.value,
    component: LanguageComponent,
    children: [
      { path: '', component: HomeComponent },
      // { path: 'staking', component: StakingComponent },
      { path: 'termsandcondition', component: TermsConditionsComponent },
      { path: 'privacypolicy', component: PrivacyPolicyComponent },
    ],
  };
});

const routes: Routes = [
  { path: 'en', redirectTo: '', pathMatch: 'full' },
  {
    path: '',
    component: LanguageComponent,
    children: [
      { path: '', component: HomeComponent },
      // { path: 'staking', component: StakingComponent },
      { path: 'termsandcondition', component: TermsConditionsComponent },
      { path: 'privacypolicy', component: PrivacyPolicyComponent },
    ],
  },
  ...routesLang,
  { path: '**', redirectTo: '', pathMatch: 'full' },
  { path: '*path', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'ignore',
      scrollPositionRestoration: 'enabled',
      useHash: false,
      urlUpdateStrategy: 'eager',
      scrollOffset: [0, 50],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
